import {emptyValue} from "./global";


function getMediumType(medium_type){
    if (medium_type === "ELECTRICITY") return "Strom";
    else if (medium_type === "GAS") return "Gas";
    else return emptyValue;
}
export default getMediumType;